// extracted by mini-css-extract-plugin
export var brand = "_72-8";
export var compact = "_72-5";
export var extraSmall = "_72-6";
export var icon = "_72-0";
export var large = "_72-3";
export var light = "_72-1";
export var medium = "_72-4";
export var outline = "_72-a";
export var primaryDark = "_72-9";
export var primaryLight = "_72-7";
export var primaryModern = "_72-b";
export var success = "_72-2";